import { useContext } from 'react';
import { ModalsContext } from './Provider';

export const useModal = () => useContext(ModalsContext)!;
